"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFieldLogicToRegistry = exports.initFieldsLogicRegistry = void 0;
const fields_logic_registry_1 = require("./fields-logic-registry");
function initFieldsLogicRegistry(fieldsConfig, fieldTypes, appRecordsService) {
    const types = Object.keys(fieldTypes);
    types.forEach((type) => {
        var _a;
        const config = (_a = fieldsConfig[type]) !== null && _a !== void 0 ? _a : {};
        const FieldClass = fieldTypes[type];
        const fieldTypeInstance = new FieldClass(config, appRecordsService);
        addFieldLogicToRegistry(type, fieldTypeInstance);
    });
}
exports.initFieldsLogicRegistry = initFieldsLogicRegistry;
function addFieldLogicToRegistry(field, logic) {
    fields_logic_registry_1.fieldsLogicRegistry[field] = logic;
}
exports.addFieldLogicToRegistry = addFieldLogicToRegistry;
